export function tabbedNav() {

    // scope within the tabbed navigation container - we dont want the active state of tabs in other tabbed navigations to be affected
    const tabbedNavigations = document.querySelectorAll('.tabbed-navigation-container');

    tabbedNavigations.forEach(nav => {
        const tabbedNavLinks = nav.getElementsByClassName('tab-link');

        const toggleNavigation = function () {
            if (!this.classList.contains("active")) {
                const parentNav = this.closest('.tabbed-navigation-container');
                if (parentNav) {
                    const tabbedContent = parentNav.querySelectorAll('.active');

                    tabbedContent.forEach(item => {
                        item.classList.remove('active');
                    });

                    this.classList.add('active');

                    const currentTab = this.getAttribute('data-target'),
                        tabContent = parentNav.querySelector(`#${currentTab}`);
                    
                    if (tabContent) {
                        tabContent.classList.add('active');
                    }
                }
            }
        };

        Array.from(tabbedNavLinks).forEach(item => {
            item.addEventListener('mouseover', toggleNavigation);
        });
    });
}